import { render, staticRenderFns } from "./DashboardBox.vue?vue&type=template&id=442d2375&scoped=true&"
import script from "./DashboardBox.vue?vue&type=script&lang=js&"
export * from "./DashboardBox.vue?vue&type=script&lang=js&"
import style0 from "./DashboardBox.vue?vue&type=style&index=0&id=442d2375&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442d2375",
  null
  
)

export default component.exports